var map = {
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"default~app-home-registrations-registrations-module~home-home-module",
		"home-home-module"
	],
	"./login/login.module": [
		"./src/app/login/login.module.ts"
	],
	"app/home/absences/absences.module": [
		"./src/app/home/absences/absences.module.ts",
		"app-home-absences-absences-module"
	],
	"app/home/employees/employees.module": [
		"./src/app/home/employees/employees.module.ts",
		"default~app-home-employees-employees-module~app-home-orgs-orgs-module~app-home-planning-planning-mod~9b25026c"
	],
	"app/home/expirations/expirations.module": [
		"./src/app/home/expirations/expirations.module.ts",
		"app-home-expirations-expirations-module"
	],
	"app/home/orgs/orgs.module": [
		"./src/app/home/orgs/orgs.module.ts",
		"default~app-home-employees-employees-module~app-home-orgs-orgs-module~app-home-planning-planning-mod~9b25026c",
		"default~app-home-orgs-orgs-module~app-home-registrations-registrations-module"
	],
	"app/home/planning/planning.module": [
		"./src/app/home/planning/planning.module.ts",
		"default~app-home-employees-employees-module~app-home-orgs-orgs-module~app-home-planning-planning-mod~9b25026c",
		"app-home-planning-planning-module"
	],
	"app/home/registrations/registrations.module": [
		"./src/app/home/registrations/registrations.module.ts",
		"default~app-home-employees-employees-module~app-home-orgs-orgs-module~app-home-planning-planning-mod~9b25026c",
		"default~app-home-orgs-orgs-module~app-home-registrations-registrations-module",
		"default~app-home-registrations-registrations-module~home-home-module",
		"app-home-registrations-registrations-module"
	],
	"app/home/reminders/reminders.module": [
		"./src/app/home/reminders/reminders.module.ts",
		"app-home-reminders-reminders-module"
	],
	"app/home/settings/educationUnits/educationUnits.module": [
		"./src/app/home/settings/educationUnits/educationUnits.module.ts",
		"default~app-home-settings-educationUnits-educationUnits-module~app-home-settings-services-services-m~ce5e4041",
		"app-home-settings-educationUnits-educationUnits-module"
	],
	"app/home/settings/services/services.module": [
		"./src/app/home/settings/services/services.module.ts",
		"default~app-home-settings-educationUnits-educationUnits-module~app-home-settings-services-services-m~ce5e4041",
		"app-home-settings-services-services-module"
	],
	"app/home/settings/users/users.module": [
		"./src/app/home/settings/users/users.module.ts",
		"app-home-settings-users-users-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;